import React, {Component} from 'react';

class TeamLogo extends Component {
    render() {
        if (!this.props.team || !this.props.team.team_id) {
            return '';
        }
        var url = urlStart + this.props.team.team_id;
        const solid = 1;

        const style = {
            opacity: this.props.opacity || solid,
        };

        if (this.props.small) {
            url = url + urlEndSmall;
        } else if (this.props.large) {
            url = url + urlEndLarge;
        }else {
            url = url + urlEndMed;
        }

        return (
            <img src={url} style={style} alt="team logo"/>
        );
    }
}

var urlStart = "https://secure.espn.com/combiner/i?img=/i/teamlogos/ncaa/500/";
var urlEndSmall= ".png?w=25&h=25";
var urlEndMed= ".png?w=50&h=50";
var urlEndLarge= ".png?w=100&h=100";

export default TeamLogo;